import React from 'react';
import { ReactComponent as arrowRight } from './arrowRight.svg';
import { ReactComponent as arrowLeft } from './arrowLeft.svg';
import { ReactComponent as burgerMenu } from './burgerMenu.svg';
import { ReactComponent as infoButton } from './infoButton.svg';
import { ReactComponent as arrowRightButton } from './arrowRightButton.svg';
import { ReactComponent as plusButton } from './plusButton.svg';
import { ReactComponent as productHammer } from './productHammer.svg';
import { ReactComponent as productMountain } from './productMountain.svg';
import { ReactComponent as productScooter } from './productScooter.svg';
import { ReactComponent as productPalette } from './productPalette.svg';
import { ReactComponent as productSnorkel } from './productSnorkel.svg';
import { ReactComponent as productbbq } from './productbbq.svg';
import { ReactComponent as productShovel } from './productShovel.svg';
import { ReactComponent as toolAlign } from './toolAlign.svg';
import { ReactComponent as toolRuler } from './toolRuler.svg';
import { ReactComponent as toolContain } from './toolContain.svg';
import { ReactComponent as toolImage } from './toolImage.svg';
import { ReactComponent as toolCamera } from './camera.svg';
import { ReactComponent as reload } from './reload.svg';
import { ReactComponent as minusButton } from './minusButton.svg';

export type svgType =
  | 'arrowRight'
  | 'arrowLeft'
  | 'burgerMenu'
  | 'arrowRightButton'
  | 'plusButton'
  | 'infoButton'
  | 'productHammer'
  | 'productMountain'
  | 'productScooter'
  | 'productPalette'
  | 'productSnorkel'
  | 'productbbq'
  | 'productShovel'
  | 'toolAlign'
  | 'toolRuler'
  | 'toolContain'
  | 'toolImage'
  | 'toolCamera'
  | 'reload'
  | 'minusButton';

export interface SVGButtonProps extends React.SVGProps<SVGSVGElement> {
  type: svgType;
}
const options: Record<
  svgType,
  React.FunctionComponent<React.SVGProps<SVGSVGElement>>
> = {
  arrowRight,
  arrowLeft,
  burgerMenu,
  arrowRightButton,
  plusButton,
  infoButton,
  productHammer,
  productMountain,
  productScooter,
  productPalette,
  productSnorkel,
  productbbq,
  productShovel,
  toolAlign,
  toolRuler,
  toolContain,
  toolImage,
  toolCamera,
  reload,
  minusButton,
};

const SummerwoodSVG: React.FunctionComponent<SVGButtonProps> = ({
  type,
  ...props
}) => {
  const Icon = options[type];
  return <Icon {...props} />;
};

export default SummerwoodSVG;
